module.exports = "/lucky-balls/img/weager/balls/color/purple.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/color/purple.png
// module id = 1181
// module chunks = 0